import { map, catchError } from 'rxjs/operators';
import { DateService } from '@core/services';
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { environment as env } from '@env/environment';
import { Observable, throwError } from 'rxjs';
import { QueryOptions, Message } from '@models/system';
import { type HttpService } from '@http/services';
import { Product } from '@models/domain';

@Injectable({
    providedIn: 'root'
})
export class ProductService implements HttpService<Product> {

    constructor(private http: HttpClient) {}

    fetch(qo: QueryOptions) : Observable<HttpResponse<Product[]>> {
        return this.http.get<Product[]>(env.API_URL + '/products', {
            params: qo.toObject(), // { offset: qo.offset, limit: qo.limit, eq: qo.eq, dig: qo.dig}, 
            observe: 'response'
        });
    }

    get(id: string) : Observable<HttpResponse<Product>> {
        return this.http.get<Product>(env.API_URL + '/products/' + id, {
            params: {},
            observe: 'response'
        }).pipe(
            map( resp => {
                if (resp.body != null && resp.body.product_id) {
                    resp.body.release_date = DateService.toDateString(resp.body.release_date);
                    resp.body.modified_datetime = DateService.toDateString(resp.body.modified_datetime);
                }
                return resp;
            })
        );
    }

    post(t: Product): Observable<HttpResponse<Product>> {
        //return throwError(() => new Error("Invalid API service call attempt"));
        t = this.sanitize(t);
        return this.http.post<Product>(env.API_URL + '/products', t, {
            params: {},
            observe: 'response'
        });
    }

    put(t: Product): Observable<HttpResponse<Message>> { 
        //return throwError(() => new Error("Invalid API service call attempt"));
        t = this.sanitize(t);
        return this.http.put<Message>(env.API_URL + '/products/' + t.product_id, t, {
            params: {},
            observe: 'response'
        });
    }

    delete(id: string) : Observable<HttpResponse<Message>> {
        //return throwError(() => new Error("Invalid API service call attempt"));
        return this.http.delete<Message>(env.API_URL + '/products/' + id, {
            params: {},
            observe: 'response'
        });
    }

    sanitize(t: Product): Product {

        //date
        t.release_date = DateService.to8601String(t.release_date);
        //number
        //t.ip_limit = parseInt(t.ip_limit + "");
        //nullable
        //t.middlename = t.middlename == "" ? null : t.middlename;

        return t
    }

}
